import Button from "components/Button/Button";
import Checkbox from "components/Checkbox/Checkbox";
import InputField from "components/InputField/InputField";
import React, { useEffect } from "react";
import ReactDatePicker from "react-datepicker";
import "./InvoicePrompter.scss";

interface IProps {
  callback: (date: Date) => void;
  reset: boolean;
}

const InvoicePrompter = ({ callback, reset }: IProps) => {
  const [startDate, setStartDate] = React.useState<Date | null>(null);
  const [manualDateInput, setManualDateInput] = React.useState("");
  const [checked, setChecked] = React.useState(false);
  const [datesMatch, setDatesMatch] = React.useState(false);
  const [disabled, setDisabled] = React.useState(true);

  useEffect(() => {
    setStartDate(null);
    setManualDateInput("");
    setChecked(false);
    setDatesMatch(false);
    setDisabled(true);
  }, [reset]);

  const handleInputUpdate = (value: string) => {
    if (startDate) {
      setManualDateInput(value);
      const day = startDate.getDate().toString().padStart(2, "0");
      const month = (startDate.getMonth() + 1).toString().padStart(2, "0");
      const year = startDate.getFullYear();
      const date = `${day}/${month}/${year}`;
      const match = date === value;
      setDatesMatch(match);
      validate(match, checked);
    }
  };

  const handleCalendarSelect = (value: Date | null) => {
    setStartDate(value);
    if (manualDateInput && value) {
      const day = value.getDate().toString().padStart(2, "0");
      const month = (value.getMonth() + 1).toString().padStart(2, "0");
      const year = value.getFullYear();
      const date = `${day}/${month}/${year}`;
      const match = date === manualDateInput;
      setDatesMatch(match);
      validate(match, checked);
    }
  };

  const handleCheckAndValidateForm = (value: boolean) => {
    setChecked(value);
    validate(datesMatch, value);
  };

  const validate = (match: boolean, _checked: boolean) => {
    if (match && _checked) {
      setDisabled(false);
    } else {
      setDisabled(true);
    }
  };

  return (
    <div className="input-invoice-date-modal">
      <ReactDatePicker
        onChange={(date) => handleCalendarSelect(date)}
        selected={startDate}
        inline
        maxDate={new Date()}
        showTimeInput
        showYearDropdown
        showMonthDropdown
        yearDropdownItemNumber={15}
        scrollableYearDropdown
      />
      <InputField
        label="In order to confirm the date you selected, please enter the date manually again with DD/MM/YYYY format."
        name="miraklBaseUrl"
        placeholder="14/03/1984"
        onChange={(e) => handleInputUpdate(e.currentTarget.value)}
        value={manualDateInput}
        errors={!datesMatch ? ["Dates do not match"] : []}
      />
      <Checkbox
        label="I hereby confirm that the invoice date is correct."
        checked={checked}
        onChange={(e) => handleCheckAndValidateForm(e.currentTarget.checked)}
      ></Checkbox>
      <Button
        content="Save & Continue to Sync"
        className="button--bordered button--green"
        disabled={disabled}
        onClick={() => callback(startDate!)}
      ></Button>
    </div>
  );
};

export default InvoicePrompter;
